export default [
    {
        path: "/autoreply",
        name: "autoreply_index",
        component: () => import("../views/autoreply/index.vue"),
        meta: { h5Header: true, h5TitleKey: "user.aiService" },
    },
];
